const lo = {
    l: {
        en: "English",
        th: "ไทย",
        lo: "ລາວ"
    },
    language: "ພາສາ",
    lang : "ລາວ",
    signIn : "ເຂົ້າສູ່ລະບົບ",
    fill_user_pass : "ກະລຸນາໃສ່ຂໍ້ມູນສະມາຊິກ",
    logout : "ອອກຈາກລະບົບ",
    register : "ລົງທະບຽນ",
    menu: {
        dashboard: "ແຜງຄວບຄຸມ",
        init_doc: "Initial Pack",
        shipment_check: "Shipment Check",
        ship_parcel: "Ship Parcel",
        drop_parcel: "Drop Parcel",
        move_parcel: "Move Parcel",
        drop_image_confirm: "Ticket Approve",
    },
    dashboard : {
        advance_money_balance: "ເງິນລ່ວງຫນ້າທີ່ຍັງເຫຼືອ",
        point_balance: "Point ທີ່ຍັງເຫຼືອ",
        advance_money_transection: "ເງິນລ່ວງຫນ້າ",
        point_transection : "Point",
        nodata: "ບໍ່ມີຂໍ້ມູນ.",
        today_packing: "Today Pack",
        today_picking: "Today Pick"
    },
    trans_flag : {
        trans_flag_40 : "Advance Money",
        trans_flag_44 : "Sales"
    },
    profile: {
        name: "Name",
        username: "Username",
        password: "Password",
        email: "Email",
        change_password: "Change Password",
        current_password: "Currrent Password",
        new_password: "New Password",
        confirm_password: "Confirm Password",
        not_scure_password: "Password not scure. Please change password",
        confirm_password_invalid: "Confirm password invalid.",
        input_invalid: "Input Invalid"
    },
    common: {
        save: "Save",
        save_success: "Save successfully.",
        save_fail: "Save failed."
    },
    Boxs: "Boxs",
    Sended: "Sended"
}

export default lo